import { ProductWithQuantity } from "./product-with-quantity";

export class RequestView {
    fromDate: string;
    toDate: string;
    locIds: number[] = [];
    locId: number;
    inventoryId: number;
    status: string;
    pageNo: number;
    pageSize: number;
    noOfRow: number;

    toLocId: number;
    toLocIds?: number[];
    invoiceTypes?: string[];
    statuses?: string[];
    currentStatus?: string[];
    statusList?: string[];

    //added for Receive Order
    dispatchedReceiveTypes?: string;

    // For Process Order
    orderNos?: string[];
    subGroupCodes?: number[];
    employeeOrVendor?: string;

    //For asset view
    departmentCodes?: number[];
    assetLocations?: string[];
    assetLifes?: number[];
    performanceCheckFrequencies?: number[];

    processTypeCodes?: number[];
    userIds?: string[];

    staffId?: string;
    staffIds?: string[] = [];
    type?: string;
    types?: string[];

    productWithQuantity?: ProductWithQuantity[];
    locationName?: string;
    userName?: string;
    orderNo?: string;
    date?: string;
    time?: string;

    codes?: any[];
    code?: number;
    anotherCodes?: number[];
    selectedLoc?: number[] = [];
    typeOfMessage?: string[] = [];
    locationWithOrderNo?: any[];

    customerCode: string[] = [];

    countryName: string[] = [];
    stateName: string[] = [];
    cityName: string[] = [];
    source: string[] = [];

    module?: string;
    parameter?: number[] = [];
    selcetedModules: string[] = [];
    riders: string[];

    locationFilter?: string;

}
